let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("je17d")).then(() => parcelRequire('22iKv'));